/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';

import Aos from 'aos';
import type { NextPage } from 'next';
import { type NextFont } from 'next/dist/compiled/@next/font';
import Image from 'next/image';
import { TypeAnimation } from 'react-type-animation';

import { AboutCarousel, PageContainer } from '../components/index';
import TheTeam, { type ITheTeamProps } from '../components/TheTeam';
import imageArr from '../public/file';
import 'aos/dist/aos.css';
// If loading a variable font, you don't need to specify the font weight

const Awards: NextPage<{ inter: NextFont }> = ({ inter }) => {
  const theTeam: ITheTeamProps[] = [
    {
      name: 'Eniola Agunbiade',
      img: 'eniola.jpg',
      category: 'Creativity',
      linkedin: 'https://www.linkedin.com/in/eniola-agunbiade-102370239',
      instagram: 'https://www.instagram.com/eniola_divine',
      twitter: 'https://twitter.com/EniolaDivine'
    },
    {
      name: 'Udochuwkuka Onyela',
      img: 'udo.jpg',
      category: 'Development',
      linkedin: 'https://www.linkedin.com/in/udochukwukaonyela/',
      github: 'https://github.com/Onyelaudochukwuka',
      twitter: 'https://twitter.com/FUMUDUKUS'
    },
    {
      name: 'Qazeem Oladejo',
      img: 'q.jpg',
      category: 'Product',
      linkedin: 'https://www.linkedin.com/in/qazeem-oladejo',
      github: 'https://github.com/oladejoishola2',
      twitter: 'https://twitter.com/mohhamedqazeem'
    },
    {
      name: 'Sinmiloluwa Oloyede',
      img: 'simi.jpg',
      category: 'Security',
      linkedin: 'https://www.linkedin.com/in/sinmiloluwa-oloyede-94962511b',
      github: 'https://www.github.com/Sinmiloluwa',
      twitter: 'http://www.twitter.com/Blvck_simons_'
    },
    {
      name: '',
      img: '',
      category: '',
      linkedin: '',
      github: '',
      twitter: '',
      hidden: true
    }
  ];
  const images = [
    {
      src: '/image-1.png'
    },
    {
      src: '/image-2.png'
    },
    {
      src: '/image-3.png'
    },
    {
      src: '/image-4.png'
    },
    {
      src: '/image-5.png'
    },
    {
      src: '/image-6.png'
    }
  ];
  useEffect(() => {
    Aos.init({
      // Global settings:
      disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
      startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
      initClassName: 'aos-init', // class applied after initialization
      animatedClassName: 'aos-animate', // class applied on animation
      useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
      disableMutationObserver: false, // disables automatic mutations' detections (advanced)
      debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
      throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)

      // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
      offset: 80, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 1500, // values from 0 to 3000, with step 50ms
      easing: 'ease', // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: 'top-bottom' // defines which position of the element regarding to window should trigger the animation
    });
    Aos.refresh();
    //  setTimeout(() => {
    //    setDisplayIncrease(true);
    //  }, 5000);
  }, []);
  return (
    <>
      <PageContainer>
        <div className={`mt-8 ${inter.className}`}>
          <div className="flex lg:flex-row flex-col items-center justify-between lg:p-12 p-8 gap-8">
            <h1 className="lg:text-left text-center lg:basis-[45%] text-2xl font-bold text-[#0c0114] lg:text-5xl md:text-3xl lg:leading-[58px] flex flex-col">
              <TypeAnimation
                sequence={['Pioneering', 5000, 'Trailblazing', 5000]}
                wrapper="span"
                cursor={true}
                repeat={Infinity}
                style={{ color: '#FA9706' }}
                speed={1}
              />
              {''}
              <span>The Biggest Tech Professionals Award In The World</span>
            </h1>
            <div className="image-container relative lg:basis-1/2 gap-5">
              {images.map((val, index) => (
                <Image
                  key={val.src}
                  src={`/about${val.src}`}
                  alt="image"
                  width={855}
                  height={630}
                  quality={100}
                  className={`h-auto w-auto relative rounded-3xl mb-auto image-${index}`}
                />
              ))}
            </div>
          </div>
          <div
            className="flex lg:flex-row flex-col-reverse "
            data-aos="slide-right"
          >
            <div className="block h-auto w-full p-6 lg:p-12">
              <Image
                src="/about/award.jpg"
                width={3328}
                height={3357}
                alt="image"
              />
            </div>
            <div className="flex w-full flex-col gap-8 p-6 lg:p-12">
              <h1
                className={
                  'relative mx-auto lg:mx-0 w-fit items-start lg:items-start text-3xl font-medium after:absolute after:left-1 after:-bottom-2 after:h-1 lg:after:w-5/12 after:w-7/12 after:rounded-full after:bg-golden'
                }
              >
                The Story
              </h1>
              <div className="flex flex-col gap-4">
                <p className="w-full lg:text-base text-sm text-justify font-light leading-[30px]">
                  The Connected Awards is a globally recognized brand that celebrates excellence in the tech industry. Since its establishment in 2021, we have successfully organized and completed <b>six regional</b> editions: Nigeria, Africans in Europe, East Africa, North Africa, West Africa, and Southern Africa. We are proud to be the first personality award in all of these regions and the first to have a region-by-region edition across the globe. Our ultimate goal is to become the biggest tech personality brand in the world, recognizing tech experts in all countries.
                </p>
                <p className="w-full lg:text-base text-sm text-justify font-light leading-[30px]">
                  At The Connected Awards, we uphold integrity, transparency, and credibility in our selection process. Our team of hardworking experts dedicates themselves to ensuring that only the best tech experts are recognized and awarded based on our strict criteria. We believe that the general public should have a say in deciding the winners in each category, which is why we give them the power to vote for their preferred candidate.
                </p>
                <p className="w-full lg:text-base text-sm text-justify font-light leading-[30px]">
                  We are passionate about what we do and are committed to achieving our set goals. Our vision is to become the first awarding brand to recognize tech experts in all countries in the world, and we will stop at nothing to achieve this. Join us as we celebrate excellence in the tech industry and inspire a new generation of tech experts.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          className="bg-[#F8F5F9] px-12 flex flex-col space-y-12 py-16"
          data-aos="fade-up"
        >
          <h1
            className={`relative w-fit text-2xl mx-auto lg:mx-0 md:text-3xl font-medium after:absolute after:left-1 after:-bottom-2 after:h-1 lg:after:w-5/12 after:w-7/12 after:rounded-full after:bg-golden lg:text-4xl 
            `}
          >
            The Team
          </h1>
          <div className="flex flex-wrap gap-12 justify-between">
            {theTeam.map((val, i) => (
              <TheTeam key={val.name} {...val} />
            ))}
          </div>
        </div>
        <div className="flex flex-col space-y-12 py-12">
          <h1
            className={`relative w-fit lg:ml-12 mx-auto lg:mr-0 text-2xl md:text-3xl font-medium after:absolute after:left-1 after:-bottom-2 after:h-1 lg:after:w-5/12 after:w-7/12 after:rounded-full after:bg-golden lg:text-4xl 
            `}
          >
            The Photo Gallery
          </h1>
          <AboutCarousel
            slides={imageArr}
            options={{ dragFree: true, align: 'end' }}
          />
        </div>
      </PageContainer>
    </>
  );
};

export default Awards;
